import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-two-col',
  templateUrl: './section-two-col.component.html',
  styleUrls: ['./section-two-col.component.css']
})
export class SectionTwoColComponent implements OnInit {

  // https://codepen.io/Mohamed-Anwar97/pen/yLOwGed
  
  constructor() { }

  ngOnInit(): void {
  }
  openCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02', '_blank');
  }

}
